/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import store from "../store/store";
import Peer from "simple-peer";
import { setLocalStream, setRemoteStreams } from "../store/slice/roomSlice";
import { signalPeerData } from "../multiplayer/SocketConnection";
import { setNotification } from "../store/slice/privateSlice";

const getConfiguration = () => {
    const turnIceServers = null;
    const STUN_SERVER = store.getState().room.configuredStunServer

    if (turnIceServers) {
        // TODO use TURN server credentials
    } else {
        console.warn("using only STUN server");
        return {
            iceServers: [
                {
                    urls: STUN_SERVER,
                },
            ],
        }
    }
}

const onlyAudioConstraints = {
    audio: true,
    video: false,
}

const defaultConstraints = {
    audio: true,
    video: false,
}

export const getLocalStreamPreview = (onlyAudio = false, callback) => {
    const constraints = onlyAudio ? onlyAudioConstraints : defaultConstraints;

    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
        store.dispatch(setLocalStream(stream));
        if(callback instanceof Function) callback();
    }).catch(err => {
        console.log(err);
        store.dispatch(setNotification("Allow the access to mic in your browser!"))
    });
}

let peers = {};

export const prepareNewPeerConnection = (connUserSocketId, isInitiator) => {
    const localStream = store.getState().room.localStream;

    peers[connUserSocketId] = new Peer({
        initiator: isInitiator,
        config: getConfiguration(),
        stream: localStream,
    });

    peers[connUserSocketId].on("signal", data => {
        const signalData = {
            signal: data,
            connUserSocketId: connUserSocketId,
        };

        signalPeerData(signalData);
    });

    peers[connUserSocketId].on("stream", (remoteStream) => {
        remoteStream.connUserSocketId = connUserSocketId;
        addNewRemoteStream(remoteStream);
    });
}

export const handleSignalingData = (data) => {
    const { connUserSocketId, signal } = data;

    if (peers[connUserSocketId])
        peers[connUserSocketId].signal(signal);

};

export const closeAllWebRTCConnections = () => {
    const localStream = store.getState().room.localStream

    if (localStream) {
        localStream.getTracks().forEach((track) => track.stop());
        store.dispatch(setLocalStream(null));
    }

    Object.entries(peers).forEach(mappedObject => {
        const connUserSocketId = mappedObject[0];
        if (peers[connUserSocketId]) {
            peers[connUserSocketId].destroy();
            delete peers[connUserSocketId];
        }
    });

    store.dispatch(setRemoteStreams([]));
};

export const closeWebRTCConnection = (disconnUserSocketId) => {
    if (peers[disconnUserSocketId]) {
        peers[disconnUserSocketId].destroy()
        delete peers[disconnUserSocketId];
    }

    const remoteStreams = store.getState().room.remoteStreams;

    const newRemoteStreams = remoteStreams.filter(remoteStream =>
        remoteStream.connUserSocketId !== disconnUserSocketId
    );

    store.dispatch(setRemoteStreams(newRemoteStreams));
}

const addNewRemoteStream = (remoteStream) => {
    const remoteStreams = store.getState().room.remoteStreams;
    const newRemoteStreams = [...remoteStreams, remoteStream];

    store.dispatch(setRemoteStreams(newRemoteStreams));
}